export default __webpack_public_path__ + "static/media/1.65b803b2.jpeg";